import { useEffect, useState } from "react";
import { apiClient } from "../App";
import { Card, CardContent } from "./ui/card";
import { CheckCircle2, Circle, Sparkles } from "lucide-react";

export default function OnboardingChecklistCard() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("tt_onboarding_dismissed") === "1"; } catch { return false; }
  });

  useEffect(() => {
    let cancelled = false;
    apiClient.get("/admin/onboarding")
      .then(res => { if (!cancelled) setData(res.data); })
      .catch(() => { if (!cancelled) setData(null); });
    return () => { cancelled = true; };
  }, []);

  if (dismissed) return null;
  if (!data) return null;
  // Auto-hide once 100% complete
  if (data.percent >= 100) return null;

  return (
    <Card className="border-indigo-200 bg-gradient-to-br from-indigo-50/50 to-white" data-testid="onboarding-checklist-card">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-indigo-600" />
            <h3 className="font-heading font-semibold text-slate-900">Get Engage Live — {data.completed}/{data.total} complete</h3>
          </div>
          <button
            className="text-xs text-slate-400 hover:text-slate-700"
            onClick={() => {
              try { localStorage.setItem("tt_onboarding_dismissed", "1"); } catch {}
              setDismissed(true);
            }}
            data-testid="onboarding-dismiss"
          >
            Dismiss
          </button>
        </div>
        <div className="w-full h-1.5 bg-slate-200 rounded-full mb-4 overflow-hidden">
          <div
            className="h-full bg-indigo-600 transition-all"
            style={{ width: `${data.percent}%` }}
            data-testid="onboarding-progress-bar"
          />
        </div>
        <div className="space-y-2">
          {data.checks.map(check => (
            <div
              key={check.id}
              className={`flex items-start gap-2 text-sm ${check.done ? "text-emerald-700" : "text-slate-600"}`}
              data-testid={`onboarding-check-${check.id}`}
            >
              {check.done
                ? <CheckCircle2 className="h-4 w-4 text-emerald-500 shrink-0 mt-0.5" />
                : <Circle className="h-4 w-4 text-slate-300 shrink-0 mt-0.5" />}
              <div className="flex-1">
                <div className={`font-medium ${check.done ? "line-through opacity-70" : ""}`}>{check.label}</div>
                {!check.done && <div className="text-[11px] text-slate-500 mt-0.5">{check.hint}</div>}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
